import { useInfiniteQuery } from '@tanstack/react-query';
import { findAction, invokeAction } from 'actions';
import { useAuthStatus } from 'features/auth';
const DEFAULT_PAGE_SIZE = 50;
export function useListAgents({ searchTerm, status }) {
    const authStatus = useAuthStatus();
    const user = authStatus.kind === 'authenticated' ? authStatus.user : null;
    const action = user ? findAction(user, 'listAgents') : null;
    const sendSearch = searchTerm.length >= 2 ? searchTerm : '';
    const sendStatus = status === 'all' ? '' : status;
    return useInfiniteQuery({
        queryKey: ['listAgents', user?.email, sendSearch, sendStatus],
        enabled: Boolean(user && action),
        initialPageParam: 1,
        getNextPageParam: (lastPage) => {
            const view = lastPage.response.filteredView;
            const total = view?.numberOfItems ?? 0;
            const pageSize = view?.pageSize ?? DEFAULT_PAGE_SIZE;
            const current = view?.currentPage ?? lastPage.page;
            // Has next if we haven't yet covered all records.
            if (current * pageSize >= total)
                return undefined;
            return current + 1;
        },
        queryFn: async ({ pageParam }) => {
            if (!user || !action)
                throw new Error('listAgents unavailable');
            const variables = {
                currentPage: String(pageParam),
                pageSize: String(DEFAULT_PAGE_SIZE),
            };
            if (sendSearch)
                variables.searchTerm = sendSearch;
            if (sendStatus)
                variables.status = sendStatus;
            const response = await invokeAction(action, user.token, { variables });
            if (!response.ok)
                throw new Error(`listAgents returned ${response.status}`);
            const json = (await response.json());
            return { response: json, page: pageParam };
        },
    });
}
